import ModalProvider from 'mui-modal-provider';
import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Outlet, useLocation } from 'react-router-dom';

import ErrorBoundary from './modules/common/components/error-boundary/error-boundary.component';
import Footer from './modules/common/components/footer/footer.component';
import { Main } from './modules/common/styles/global.styles';

function App() {
  const location = useLocation();
  useEffect(() => {
    const body = document.querySelector('body');
    if (body) {
      body.style.height = /\/atlas*/gm.test(location.pathname) ? '100vh' : '';
      body.style.overflow = /\/atlas*/gm.test(location.pathname)
        ? 'hidden'
        : 'auto';
    }
  }, [location]);
  return (
    <HelmetProvider>
      <ErrorBoundary>
        <Main component="main">
          <ModalProvider>
            <Outlet />
            <Footer />
          </ModalProvider>
        </Main>
      </ErrorBoundary>
    </HelmetProvider>
  );
}

export default App;
